import Search from 'antd/lib/input/Search'
import React, { useCallback, useState } from 'react'
import styles from './Search.module.scss'

interface ISearch {
  value?: string
  onChange: Function
  translations: any
  delaySearch?: boolean
}

const CustomSearch: React.FC<ISearch> = ({ value, onChange, translations, delaySearch = false }) => {
  let onChangeTimeout: ReturnType<typeof setTimeout>
  const [auxValue, setValue] = useState(value)
  const onChangeCallBack = useCallback((valueSearch: string) => {
    clearTimeout(onChangeTimeout)
    if (delaySearch) {
      onChangeTimeout = setTimeout(() => {
        onChange(valueSearch)
      }, 300)
    } else {
      onChange(valueSearch)
    }
  }, [])

  return (
    <div className={styles.searchContainer}>
      <Search
        className={`rankmiTable-searchInput ${styles.searchInput}`}
        data-test={'rankmi-table-search'}
        placeholder={translations.header.search}
        value={auxValue}
        onChange={(e: any) => {
          delaySearch ? onChangeCallBack(e.target.value) : onChange(e.target.value)
          setValue(e.target.value)
        }}
      />
    </div>
  )
}

export default CustomSearch
